<script lang="ts">
  import HeadingWithAnchorLink from '../blocks/HeadingWithAnchorLink.svelte';

  import { EditorJs } from 'query-strapi-v4';
  type Block = $$Generic<EditorJs.Header | undefined>;
  export let block = undefined as Block;
</script>

<HeadingWithAnchorLink id={block.data.text} level={block.data.level}>
  {@html block.data.text}
</HeadingWithAnchorLink>
